import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { FORM_KEYS } from "../../../../../constants";

/**
 * @desc Schema for Orders form.
 */
const createSchema = (cnames) =>
  yup.object({
    [FORM_KEYS.CID]: yup
      .string()
      .required("Required")
      .matches(/^[a-zA-Z-_0-9]*$/gi, () => "AlphaNumeric Hypens Only")
      .notOneOf(cnames, "Convention ID already exists."),
  });

/**
 * @desc Hook for validating order form.
 */
export const useConventionIdForm = (cnames = []) => {
  return useForm({
    resolver: yupResolver(createSchema(cnames)),
    mode: "all",
  });
};
